// extracted by mini-css-extract-plugin
export var md = "_2d-4";
export var semantic = "_2d-5";
export var sm = "_2d-3";
export var text = "_2d-6";
export var toggleInput = "_2d-0";
export var toggleSwitch = "_2d-1";
export var xs = "_2d-2";